module.exports = __webpack_public_path__ + "2a7fa01432473d286b73efd8630b939b.jpg";